import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/simulations')({
  beforeLoad: () => {
    throw redirect({ to: '/history' })
  },
  component: SimulationsPage,
})

function SimulationsPage() {
  // This component won't render due to redirect
  return null;
}
